// extracted by mini-css-extract-plugin
module.exports = {"pdf-view-wrap":"pdf-view-wrap___3HnQp","pdfViewWrap":"pdf-view-wrap___3HnQp"};